import { isBlank } from 'utils'

import CartLine from 'components/CartLine'
import SubHeader from 'components/SubHeader'

import { Root } from './Cart.style'

const Cart = ({ cart }) => {
  if (isBlank(cart)) return null

  const lines = cart?.lines?.edges?.map((edge) => edge.node) || []

  return (
    <Root>
      <thead>
        <tr>
          <th>
            <SubHeader>Product</SubHeader>
          </th>
          <th>
            <SubHeader>Qty.</SubHeader>
          </th>
          <th>
            <SubHeader>Total</SubHeader>
          </th>
        </tr>
      </thead>
      <tbody>
        {lines.map((line) => (
          <CartLine key={line.id} line={line} />
        ))}
      </tbody>
      {/* <tfoot>
        <tr>
          <td colSpan={3}>
            <Text font="stint" size="lg">
              {formatMoney(cart.estimatedCost.subtotalAmount.amount, { fractional: false })}
            </Text>
          </td>
        </tr>
      </tfoot> */}
    </Root>
  )
}

Cart.propTypes = {}

Cart.defaultProps = {}

export default Cart
